module.exports = __webpack_public_path__ + "media/images/Twitter_Social_Icon_Circle_Color@3x-2b681670ccc04565305618690eaaf101.png";